import { Reducer } from "redux";
import Loading from "../../../components/Loading";
import { Monitoring, MonitoringState, MonitoringTypes } from "./types";

export const INITIAL_STATE: MonitoringState = {
  data: {
    data: {
      default_loading_tab: "0",
      default_loading_sub_tab: "0",
      tabs: [],
    },
    message: "",
  },
  loading: false,
  success: false,
  error: false,
};

const reducer: Reducer<MonitoringState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case MonitoringTypes.LOAD_REQUEST:
      return {
        ...state,
        loading: true,
        error: false,
        success: false,
      };
    case MonitoringTypes.LOAD_SUCCESS:
      return {
        ...state,
        data: action.payload,
        loading: false,
        error: false,
        success: true,
      };
    case MonitoringTypes.LOAD_FAILURE:
      return {
        ...state,
        loading: false,
        error: true,
        success: false,
      };
    default:
      return state;
  }
};

export default reducer;
